import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';
import $ from 'jquery';
import '@/js/modules/jquery_modal_defaults';

const ADD_NEW_VENDOR_OPTION = '+new_vendor';

export default class extends Controller {
  static targets = ['select', 'accountNumber'];
  static values = { newVendorUrl: String };
  #previousValue;

  connect() {
    this.#previousValue = this.selectTarget.value;
  }

  async change() {
    if (this.selectTarget.value !== ADD_NEW_VENDOR_OPTION) {
      this.#previousValue = this.selectTarget.value;
      this.#updateAccountNumber();
      return;
    }

    this.selectTarget.value = this.#previousValue;

    const request = new FetchRequest('get', this.newVendorUrlValue, { responseKind: 'html' });
    const response = await request.perform();
    if (response.ok) {
      $(await response.html)
        .appendTo('body')
        .modal();
    }
  }

  vendorCreated(event) {
    const { id, company_name: companyName, account_number: accountNumber } = event.detail;
    const addNewOption = this.selectTarget.querySelector(
      `option[value='${ADD_NEW_VENDOR_OPTION}']`
    );
    const option = new Option(companyName, id);

    if (accountNumber) {
      option.dataset.accountNumber = accountNumber;
    }
    this.selectTarget.insertBefore(option, addNewOption);
    this.selectTarget.value = id;
    this.#previousValue = this.selectTarget.value;
    this.#updateAccountNumber();
  }

  #updateAccountNumber() {
    const selectedOption = this.selectTarget.selectedOptions[0];

    this.accountNumberTarget.value = selectedOption?.dataset.accountNumber ?? '';
  }
}
